import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'

Vue.config.productionTip = false
Vue.prototype.$ASSET_URL = process.env.VUE_APP_DIRECTUS_URL + '/assets/'

import { Directus } from "@directus/sdk";
const client = new Directus(process.env.VUE_APP_DIRECTUS_URL)

Object.defineProperties(Vue.prototype, {
  $client: { value: client },
  $DIRECTUS_ASSET_URL: {value: process.env.VUE_APP_DIRECTUS_ASSETS_URL}
})


new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
